<template>
  <div class="home-container">
    <!-- HERO SECTION -->
    <section class="hero-section">
      <div class="hero-bg">
        <!-- Assuming the background is the cargo ship image -->
      </div>
      <div class="hero-content">
        <div class="hero-badge fade-in-up">Shipping Korea ↔ China</div>
        <h1 class="hero-title fade-in-up delay-1">한국과 중국을 잇는<br/>신뢰의 물류 파트너</h1>
        <p class="hero-desc fade-in-up delay-2">상품 입고부터 결제 배송까지, 하나의 플랫폼에서 편리하게!</p>
      </div>
      <!-- Background Text -->
      <div class="hero-bg-text">
        DELIVERY<br/>GROUP
      </div>
    </section>

    <!-- BUSINESS SHOWCASE SECTION -->
    <section class="business-showcase">
      <div class="inner-container">
        <div class="section-header-modern">
          <div class="title-group">
            <h2 class="main-biz-title">주요 <span class="text-orange">사업 분야</span></h2>
            <p class="section-sub">로켓고의 핵심 물류 및 비즈니스 솔루션을 소개합니다</p>
          </div>
          
          <div class="biz-nav-toggle">
            <button :class="{active: activeCategory === 'individual'}" @click="activeCategory = 'individual'">개인 서비스</button>
            <span class="v-line"></span>
            <button :class="{active: activeCategory === 'business'}" @click="activeCategory = 'business'">사업자 서비스</button>
          </div>
        </div>

        <div class="biz-panel-grid">
          <div 
            v-for="(item, index) in activeServices" 
            :key="activeCategory + index" 
            class="biz-panel"
          >
            <div class="panel-content">
              <div class="biz-icon-box">
                <img :src="item.icon" class="biz-icon-img" alt="icon">
              </div>
              <div class="biz-info-box">
                <div class="biz-tag">사업 영역 0{{index + 1}}</div>
                <h3 class="biz-item-title">{{item.title}}</h3>
                <p class="biz-item-desc">{{item.desc}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- EVENT BANNER SECTION -->
    <section class="event-banner-section">
      <div class="inner-container">
        <div class="event-banner">
          <div class="banner-text">
            <h2>다양한 혜택 이벤트</h2>
            <h3>GUIDE & EVENT</h3>
            <router-link to="/noticeList">
              <button class="btn-readmore">자세히보기 <i class="el-icon-right"></i></button>
            </router-link>
          </div>
          <div class="banner-img">
            <!-- Placeholder for the orange illustration -->
          </div>
        </div>
      </div>
    </section>

    <!-- QUICK ACCESS SECTION -->
    <section class="quick-access-section">
      <div class="inner-container">
        <div class="section-header text-center">
          <h2 class="section-title text-orange">빠른 서비스</h2>
          <p class="section-sub">Quick Access</p>
        </div>
        <div class="quick-grid">
          <router-link to="/deliveryPrice" class="q-card reveal-card slide-left" style="text-decoration: none;">
            <div class="q-icon">
              <img src="../assets/icon/fast-delivery.png" class="q-icon-img" alt="price">
            </div>
            <div class="q-title">배송비 →</div>
          </router-link>
          <router-link to="/documentSchedule" class="q-card reveal-card slide-right" style="text-decoration: none;">
            <div class="q-icon">
              <img src="../assets/icon/calendar.png" class="q-icon-img" alt="schedule">
            </div>
            <div class="q-title">배송일정 →</div>
          </router-link>
          <div @click="showCalculator = true" class="q-card reveal-card slide-left" style="text-decoration: none;">
            <div class="q-icon">
              <img src="../assets/icon/calculator.png" class="q-icon-img" alt="calc">
            </div>
            <div class="q-title">견적 계산기 →</div>
          </div>
          <router-link to="/documentAddress" class="q-card reveal-card slide-right" style="text-decoration: none;">
            <div class="q-icon">
              <img src="../assets/icon/gps-navigation.png" class="q-icon-img" alt="address">
            </div>
            <div class="q-title">중국주소 입력방법 →</div>
          </router-link>
        </div>
      </div>
    </section>

    <CalculatorModal v-model="showCalculator" />

  </div>
</template>

<script>
import { safePush } from '@/utils/router'
import CalculatorModal from '@/components/CalculatorModal.vue'

export default {
  components: {
    CalculatorModal
  },
  data() {
    return {
      showCalculator: false,
      observer: null,
      activeCategory: 'individual',
      individualServices: [
        { 
          title: '배송대행', 
          desc: '한국과 중국을 잇는 가장 빠르고 안전한 물류 서비스로 소중한 물품을 전해드립니다.',
          icon: require('../assets/icon/gen_flat_shipping.png')
        },
        { 
          title: '등급이전', 
          desc: '타사에서 받으시던 우대 혜택 그대로, 로켓고에서 더욱 업그레이드된 멤버십을 경험하세요.',
          icon: require('../assets/icon/gen_flat_grade.png')
        },
        { 
          title: '안심보장', 
          desc: '파손 걱정 없는 꼼꼼한 검수와 프리미엄 포장 서비스로 안심하고 쇼핑에만 집중하세요.',
          icon: require('../assets/icon/gen_flat_safe.png')
        },
        { 
          title: '추천인 리워드', 
          desc: '함께할수록 커지는 혜택! 친구에게 소개하고 다양한 리워드 포인트를 적립해보세요.',
          icon: require('../assets/icon/gen_flat_reward.png')
        }
      ],
      businessServices: [
        { 
          title: '기업 배송대행', 
          desc: '대량 물량 처리에 최적화된 사업 전용 물류 솔루션으로 비즈니스 경쟁력을 높여드립니다.',
          icon: require('../assets/icon/gen_flat_corporate.png')
        },
        { 
          title: '구매대행', 
          desc: '복잡한 해외 결제와 소싱을 한번에! 전문가가 지원하는 체계적인 사업자 구매 솔루션입니다.',
          icon: require('../assets/icon/Purchase Proxy).png')
        },
        { 
          title: '재고 및 3PL', 
          desc: '스마트한 창고 관리와 재고 최적화 서비스로 물류 운영의 효율을 극대화해드립니다.',
          icon: require('../assets/icon/Inventory and 3PL.png')
        },
        { 
          title: '결제대리 서비스', 
          desc: '해외 송금과 결제의 번거로움을 해결하는 로켓고만의 간편하고 안전한 결제 대행 시스템입니다.',
          icon: require('../assets/icon/Payment Agency.png')
        }
      ]
    };
  },
  computed: {
    activeServices() {
      return this.activeCategory === 'individual' ? this.individualServices : this.businessServices;
    }
  },
  mounted() {
    this.initScrollReveal();
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    onNav(url) {
      safePush(this.$router, url);
    },
    initScrollReveal() {
      const options = {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      }, options);

      this.reObserve();
    },
    reObserve() {
      this.$nextTick(() => {
        const revealElements = document.querySelectorAll('.reveal-card');
        revealElements.forEach(el => this.observer.observe(el));
      });
    }
  },
  watch: {
    activeCategory() {
      this.reObserve();
    }
  }
}
</script>

<style scoped>


.home-container {
  background-color: #ffffff;
  color: #333;
  min-height: 100vh;
}

/* Base Utility */
.inner-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}
.text-center { text-align: center; }
.text-orange { color: #F7941D !important; }
.mt-80 { margin-top: 80px; }

.section-title {
  font-size: 38px;
  font-weight: 700;
  margin-bottom: 8px;
}
.section-sub {
  font-size: 22px;
  color: #999;
  font-weight: 400;
}

/* HERO SECTION */
.hero-section {
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 10%;
  overflow: hidden;
  background-color: #0b1a2d; /* Fallback color for ship image */
}
.hero-bg {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: url('https://admin.goroketgo.com/assets/img/main_bg.jpg') no-repeat center center / cover;
  filter: brightness(0.6);
  z-index: 1;
}
.hero-content {
  position: relative;
  z-index: 3;
  color: #fff;
  max-width: 600px;
}
.hero-badge {
  display: inline-block;
  background: #F7941D;
  color: #fff;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 20px;
}
.hero-title {
  font-size: 62px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 24px;
  letter-spacing: -1px;
}
.hero-desc {
  font-size: 24px;
  color: #e0e0e0;
  font-weight: 400;
}

.hero-bg-text {
  position: absolute;
  right: 5%;
  top: 20%;
  font-size: 80px;
  font-weight: 900;
  color: rgba(255,255,255,0.05); /* Very faint watermark text */
  text-align: right;
  line-height: 1;
  z-index: 2;
  pointer-events: none;
}

/* BUSINESS SHOWCASE - CORPORATE STYLE */
.business-showcase {
  padding: 160px 0;
  background-color: #fff;
}

.section-header-modern {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 60px;
}

.main-biz-title {
  font-size: 54px;
  font-weight: 900;
  color: #1E3A5F;
  margin-bottom: 10px;
  letter-spacing: -1.5px;
}

.biz-nav-toggle {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  padding: 5px;
  border-radius: 12px;
}
.biz-nav-toggle button {
  border: none;
  background: transparent;
  padding: 12px 25px;
  font-size: 15px;
  font-weight: 700;
  color: #888;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s;
}
.biz-nav-toggle button.active {
  background: #fff;
  color: #F7941D;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}
.v-line {
  width: 1px;
  height: 20px;
  background: #ddd;
  margin: 0 10px;
}

.biz-panel-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.biz-panel {
  position: relative;
  height: 280px;
  border-radius: 24px;
  overflow: hidden;
  background-color: #f4f7f9;
  border: 1px solid #eee;
  /* Removed hover interaction */
  cursor: default;
}

.panel-content {
  position: relative;
  height: 100%;
  padding: 40px 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  z-index: 2;
}

.biz-icon-box {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.biz-icon-img {
  width: 140px;
  height: 140px;
  object-fit: contain;
}

.biz-info-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.biz-tag {
  font-size: 13px;
  font-weight: 700;
  color: #F7941D;
  background: rgba(247, 148, 29, 0.1);
  width: fit-content;
  padding: 4px 14px;
  border-radius: 4px;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
}

.biz-item-title {
  font-size: 34px;
  font-weight: 800;
  color: #1E3A5F;
  margin-bottom: 12px;
  line-height: 1.2;
}

.biz-item-desc {
  font-size: 22px;
  line-height: 1.6;
  color: #666;
  max-width: 100%;
}

/* EVENT BANNER SECTION */
.event-banner-section {
  padding: 0 0 100px 0;
  background-color: #ffffff;
}
.event-banner {
  background-color: #fda98b;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 72px;
  height: 350px; /* Adjusted height to match image aspect ratio */
  position: relative;
  overflow: hidden;
}
.banner-text h2 {
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 5px;
}
.banner-text h3 {
  font-size: 20px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 20px;
}
.btn-readmore {
  background: #222;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background 0.3s;
}
.btn-readmore:hover {
  background: #000;
}
.banner-img {
  width: 100%;
  height: 100%;
  background: url('../assets/event_banner.png') no-repeat center center / cover;
  position: absolute;
  transform: scaleX(-1);
  transform-origin: center center;
  right: 0;
  top: 0;
  z-index: 1;
  pointer-events: none;
}
.banner-text {
  position: relative;
  z-index: 2; /* Ensure text is above image if they overlap */
}

/* QUICK ACCESS SECTION */
.quick-access-section {
  padding: 100px 0;
  background-color: #f5f5f5;
}
.quick-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}
.q-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e0e0;
}
.q-card:hover {
  background: #fff;
  transform: translateY(-5px);
  border-color: #F7941D;
  box-shadow: 0 8px 30px rgba(0,0,0,0.08);
}
.q-icon {
  margin-bottom: 20px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.q-icon-img {
  height: 48px;
  object-fit: contain;
  filter: brightness(0) saturate(100%) invert(18%) sepia(30%) saturate(700%) hue-rotate(180deg) brightness(90%) contrast(90%);
  transition: transform 0.3s;
}
.q-card:hover .q-icon-img {
  transform: scale(1.1);
  filter: brightness(0) saturate(100%) invert(62%) sepia(85%) saturate(1200%) hue-rotate(1deg) brightness(102%) contrast(96%);
}
.q-title {
  font-size: 20px;
  font-weight: 700;
  color: #1E3A5F;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  line-height: 1.4;
  transition: color 0.3s;
}
.q-card:hover .q-title {
  color: #F7941D;
}
.q-title i {
  color: #888;
  font-size: 18px;
  transition: transform 0.3s;
}
.q-card:hover .q-title i {
  color: #F7941D;
  transform: translateX(5px);
}

/* SCROLL REVEAL ANIMATIONS */
.reveal-card {
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
}

.reveal-card.slide-left {
  transform: translateX(-100px);
}

.reveal-card.slide-right {
  transform: translateX(100px);
}

.reveal-card.is-visible {
  opacity: 1;
  transform: translateX(0);
}

/* Stagger for grid items if needed, but manual delay is easier for precise control */
.service-grid .reveal-card:nth-child(2) { transition-delay: 0.1s; }
.service-grid .reveal-card:nth-child(3) { transition-delay: 0.2s; }
.service-grid .reveal-card:nth-child(4) { transition-delay: 0.3s; }

/* Simple fade animations */
.fade-in-up {
  opacity: 0;
  animation: fadeInUp 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
.delay-1 { animation-delay: 0.2s; }
.delay-2 { animation-delay: 0.4s; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* RESPONSIVE QUERIES */
@media (max-width: 992px) {
  .biz-panel-grid, .quick-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .hero-title {
    font-size: 40px;
  }
}
@media (max-width: 768px) {
  .biz-panel-grid, .quick-grid {
    grid-template-columns: 1fr;
  }
  .section-header-modern {
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
  }
  .main-biz-title {
    font-size: 36px;
  }
  .biz-panel {
    height: auto;
    min-height: 320px;
  }
  .panel-content {
    flex-direction: column;
    padding: 30px;
    text-align: center;
    gap: 20px;
  }
  .biz-icon-box {
    margin-bottom: 0;
  }
  .biz-info-box {
    align-items: center;
  }
  .biz-tag {
    margin-left: auto;
    margin-right: auto;
  }
  .biz-item-title {
    font-size: 28px;
  }
  .event-banner {
    flex-direction: column;
    text-align: center;
    padding: 30px;
  }
  .banner-img {
    margin-top: 20px;
    width: 100%;
    background-position: center;
  }
  .category-title {
    flex-direction: column;
    align-items: flex-start;
  }
  .category-title h3 {
    margin-bottom: 10px;
  }
}
</style>
